import { PaginationRange } from './pagination-range';

export class PaginationData<T> {
  constructor(
    readonly data: T[],
    readonly paginationRange = new PaginationRange()
  ) {}
}
